import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/AdminsTable.vue"),
          meta: {
            title: "Список пользователей, обслуживающих систему",
            activeMenuParent: true,
          },
          hidden: true,
        },
        {
          path: "create",
          component: () => import("@/views/forms/AdminsForm.vue"),
          meta: { title: "Создать администратора", activeMenuParent: true },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/AdminsForm.vue"),
          meta: {
            title: "Редактировать администратора",
            activeMenuParent: true,
          },
          hidden: true,
        },
      ],
    },
  ];
};
